/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type PublicCreateSourceV2Dto = {
    /**
     * Name of the source
     */
    name: string;
    /**
     * Source type
     */
    type: PublicCreateSourceV2Dto.type;
};

export namespace PublicCreateSourceV2Dto {

    /**
     * Source type
     */
    export enum type {
        ATHENA = 'ATHENA',
        BIGQUERY = 'BIGQUERY',
        REDSHIFT = 'REDSHIFT',
        SNOWFLAKE = 'SNOWFLAKE',
        DATABRICKS = 'DATABRICKS',
        DATABRICKS_JOBS = 'DATABRICKS_JOBS',
        MSSQL = 'MSSQL',
        MYSQL = 'MYSQL',
        POSTGRESQL = 'POSTGRESQL',
        ORACLE = 'ORACLE',
        SYNAPSE = 'SYNAPSE',
        LOOKER = 'LOOKER',
        TABLEAU = 'TABLEAU',
        QUICKSIGHT = 'QUICKSIGHT',
        MICROSTRATEGY = 'MICROSTRATEGY',
        QLIK = 'QLIK',
        ADF = 'ADF',
        AIRFLOW = 'AIRFLOW',
        MWAA = 'MWAA',
        DBT = 'DBT',
        DBTCLOUD = 'DBTCLOUD',
        FIVETRAN = 'FIVETRAN',
        POWER_BI = 'POWER_BI',
        DECLARATIVE = 'DECLARATIVE',
    }


}
